import {
  AddedBadge,
  BrandLogo,
  BrandLogoItem,
} from '~/screens/PageBuilder/modals/BrandExperienceModal';

interface AvailableLogosProps {
  brandName: string;
  brandDomain: string;
  logos: BrandLogoItem[];
  onBrandSelect: (logo: string, name: string) => void;
}

const getLogoUrl = (brandDomain: string, variant: 'full' | 'standard') =>
  variant === 'full'
    ? `https://cdn.brandfetch.io/${brandDomain}/w/399/h/399/logo?c=1idan6GYmsZ2_dC4Lhg`
    : `https://cdn.brandfetch.io/${brandDomain}/w/399/h/399?c=1idan6GYmsZ2_dC4Lhg`;

export const AvailableLogos = ({
  brandName,
  brandDomain,
  logos,
  onBrandSelect,
}: AvailableLogosProps) => {
  const fullLogoUrl = getLogoUrl(brandDomain, 'full');
  const standardLogoUrl = getLogoUrl(brandDomain, 'standard');

  const isFullLogoAdded = logos.some((logo) => logo.url === fullLogoUrl);
  const isStandardLogoAdded = logos.some(
    (logo) => logo.url === standardLogoUrl,
  );

  return (
    <div
      className="flex w-full flex-col gap-4 overflow-y-auto"
      style={{
        maxHeight: '380px',
      }}
    >
      <h3 className="text-root-size-body-xl font-400 text-neutral-700">
        Available <span className="font-500 text-neutral-800">{brandName}</span>{' '}
        logos
      </h3>

      <div className="flex gap-2">
        <div className="relative size-32">
          <BrandLogo
            src={fullLogoUrl}
            alt={`${brandName} logo variant`}
            variant="full"
            disabled={isFullLogoAdded}
            onClick={() => onBrandSelect(fullLogoUrl, brandName)}
          />
          <AddedBadge isVisible={isFullLogoAdded} />
        </div>
        <div className="relative size-32">
          <BrandLogo
            src={standardLogoUrl}
            alt={`${brandName} standard logo`}
            variant="standard"
            disabled={isStandardLogoAdded}
            onClick={() => onBrandSelect(standardLogoUrl, brandName)}
          />
          <AddedBadge isVisible={isStandardLogoAdded} />
        </div>
      </div>
    </div>
  );
};
